import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BadgeIssue, DigitalBadge, competitorBadgeIssue } from 'src/app/models/digital-badge';
import { EventModel } from 'src/app/models/event-model';
import { ResultCollection } from 'src/app/models/result-collection';
import { ResultItem } from 'src/app/models/result-item';
import { SkillCollection } from 'src/app/models/skill-collection';
import { DigitalBadgeService } from 'src/app/services/digital-badge.service';
import { EventsService } from 'src/app/services/event.service';
import { ResultService } from 'src/app/services/result.service';
import { Skill } from 'src/app/skill';

@Component({
  selector: 'app-event-badges',
  templateUrl: './event-badges.component.html',
  styleUrls: ['./event-badges.component.css']
})
export class EventBadgesComponent implements OnInit {

  event: EventModel;
  badges: DigitalBadge[];
  resultCollection: ResultCollection;
  skillCollection: SkillCollection;

  constructor(public route: ActivatedRoute, private events: EventsService, private results: ResultService, private badgeService: DigitalBadgeService) { }

  ngOnInit() {
    this.event = this.initEventModel();
    this.route.params.subscribe(
      params =>  {
        if (params.hasOwnProperty('id')) {
          const id = Number.parseInt(params.id, 10);
          this.events.get(id).subscribe(nextEvent => {
            this.event = nextEvent;
            this.events.getSkills(this.event.id).subscribe(
              nextSkills => {
                this.skillCollection = nextSkills;
                this.loadData();
              }
            );
          });
        }
      }
    );
  }

  issueAllBadges() {
    const data: BadgeIssue[] = [];
    this.resultCollection.results.forEach(result => {
      result.competitors.forEach(competitor => {
        const item = new competitorBadgeIssue(
          competitor.person_id, this.event.name, result.skill.name.text, result.skill.number, result.member.name.text, result.medal.name.text
        );
        data.push(item);
      });
    });
    this.badgeService.issueBadgeBulk(data).subscribe(
      next => {
        this.loadData(); // reload
      },
      error => console.log(error)
    );
  }

  issueBadgesForSkill(skill: Skill) {
    const data: BadgeIssue[] = [];
    this.getResultsForSkill(skill).forEach(result => {
      const medalName = result.medal == null ? '' : result.medal.name.text;
      result.competitors.forEach(competitor => {
        const item = new competitorBadgeIssue(
          competitor.person_id, this.event.name, result.skill.name.text, result.skill.number, result.member.name.text, medalName
        );
        data.push(item);
      });
    });
    this.badgeService.issueBadgeBulk(data).subscribe(
      next => {
        this.loadData(); // reload
      },
      error => console.log(error)
    );
  }

  showIssueAllBadgesForSkill(result: ResultItem, name: string) {
    const state = this.getBadgeState(result, name);
    if (state == 'Not Issued') {
      return true;
    }
    return false;
  }

  issueAllBadgesForPerson(result: ResultItem) {
    const data: BadgeIssue[] = [];

    const medalName = result.medal == null ? '' : result.medal.name.text;
    result.competitors.forEach(competitor => {
      const item = new competitorBadgeIssue(
        competitor.person_id, this.event.name, result.skill.name.text, result.skill.number, result.member.name.text, medalName
      );
      data.push(item);
    });

    this.badgeService.issueBadgeBulk(data).subscribe(
      next => {
        this.loadData(); // reload
      },
      error => console.log(error)
    );
  }

  initEventModel() {
    const eventModel: EventModel = {
      id: null,
      name: null,
      type: null,
      start_date: null,
      end_date: null,
      competition_start_date: null,
      competition_end_date: null,
      venue: null,
      town: null,
      code: null,
      country: { id: null, code: null, name: { lang_code: null, text: null } },
      utc_offset: null,
      url: null,
      description: null,
      ws_entity: { id: null, name: { lang_code: null, text: null } }
    };

    return eventModel;
  }

  loadData() {
    this.results.getResultsForEvent(this.event.id, true).subscribe(
      nextResult => {
        this.resultCollection = nextResult;
      }
    );

    this.badgeService.getForEvent(this.event.name).subscribe(
      next => {
        this.badges = next;
      }
    );
  }

  getBadgeState(result: ResultItem, badgeName: string): string {
    if (this.badges == null) {
      return 'Not Issued';
    }
    const personIds = result.competitors.map(x => x.person_id)
    const badge= this.badges.find(x => personIds.includes(x.person.id) && x.template.name == badgeName);
    if (badge) {
      if (badge.onCredly)
      {
        return "Issued";
      } else {
        return "Issued, but not accepted";
      }
    } else {
      return 'Not Issued';
    }
  }

  getResultsForSkill(skill: Skill): ResultItem[] {
    return this.resultCollection.results.filter(x => x.skill.id == skill.id);
  }


}
